import React from "react";
import { PinInput } from "react-input-pin-code";

import securityPinCodestyles from "./securityPinCode.module.scss";

export const SecurityCodeForm = (props: any) => {
  const { onChange } = props;
  const [values, setValues] = React.useState(["", "", "", "", "", ""]);
  return (
    <div dir="ltr" className={securityPinCodestyles.container}>
      <PinInput
        name={"securityCode"}
        placeholder=""
        type="number"
        values={values}
        mask={true}
        autoFocus={true}
        onChange={(value, index, values) => {
          setValues(values);
          onChange(values.join(""));
        }}
        focusBorderColor={"#5BBDFF"}
        validBorderColor={"#E7E9EA"}
        inputStyle={
          props.securityPinCodestyles
            ? { ...props.securityPinCodestyles }
            : {
                background: "#FFFFFF",
                borderRadius: `8px`,
                fontFamily: "IBM Plex Sans Arabic",
                fontWeight: 700,
                color: "#000000",
                height: "60px",
              }
        }
      />
    </div>
  );
};
